//TODO: elementio temporal hasta que existan los iconos de POIs
// import IconPromise from 'components/widgets/IconPromise/IconPromise';
import { useSelector } from 'react-redux';
import { categoryState } from 'redux/slices/categorySlice';
// import { ReactComponent as Ic_Location_Dark } from 'resources/icons/Ic_Location_Dark.svg';
import {  iconsState } from 'redux/slices/iconsSlice';
import { getIcon } from 'utils/mapUtils';
import Image from 'components/commons/image/Image';



import './codePoi.scss';
import { TYPES_MARKERS } from 'utils/constants';
// import SvgIcon from 'components/commons/icons/SvgIcon';

interface ICodePoi {
  id?:string | number
  routeColor?:string
  light?:boolean
  styles?:React.CSSProperties;
  stylesImg?: string;
  color?:string;
  onClick?:()=>void;
  categoryId: string;
}


export default function CodePoi(props:ICodePoi) {

  const { styles, onClick, categoryId, color, stylesImg } = props;
  const selectorPoiCategories = useSelector(categoryState);
  const iconsStore = useSelector(iconsState) as any;
  const poiData = selectorPoiCategories?.find(p => Number(p.id) === Number(categoryId));

  return (
    <div className='codePoi' style={{ background: color || poiData?.color || '#489aca',...styles}} onClick={()=> onClick && onClick()}>
     <Image
      className={`code-poi-img ${stylesImg}`}
      src={ getIcon(poiData?.iconId ?? '245', iconsStore, TYPES_MARKERS.POI) }
      />
    </div>
  );
}
